<div class="height-100 gray-bg">
  <div class="wrapper wrapper-content">
    <div class="ibox col-lg-8 col-lg-offset-2">
      <div class="ibox-title">
        <h2>Exportador</h2>
      </div>
      <div class="ibox-content">
        <uib-accordion>
          <div uib-accordion-group class="panel-default" is-disabled="exp.step !== 1" is-open="exp.step === 1">
            <uib-accordion-heading>
              1.
              <span ng-if="exp.step === 1">Selecione o tipo de relatório</span>
              <span ng-if="exp.step > 1">Tipo: {{exp.selectedType.description}}</span>
              <i class="pull-right fa fa-check" ng-if="exp.step > 1"></i>
            </uib-accordion-heading>
            <form ng-submit="exp.submitType($event)">
              <div class="form-group">
                <ui-select ng-model="exp.selectedType" theme="bootstrap">
                  <ui-select-match allow-clear="true" placeholder="Procure um tipo">{{$select.selected.description}}</ui-select-match>
                  <ui-select-choices repeat="type in exp.availableTypes | filter: $select.search">
                    <span class="form-group" ng-bind-html="type.description | highlight: $select.search"></span>
                  </ui-select-choices>
                </ui-select>
              </div>
              <button type="submit" class="btn btn-info btn-block" ng-disabled="!exp.selectedType">
                Próximo
                <i class="fa fa-chevron-down"></i>
              </button>
            </form>
          </div>

          <div uib-accordion-group class="panel-default" is-disabled="exp.step !== 2" is-open="exp.step === 2">
            <uib-accordion-heading>
              2. Filtre o relatório
              <i class="pull-right fa fa-check" ng-if="exp.step > 2"></i>
            </uib-accordion-heading>
            <form ng-submit="exp.submitFilters($event)" class="form-horizontal">
              <exportador-filter-field ng-repeat="filter in exp.availableFilters" value="exp.filters[filter.name]" schema="filter"></exportador-filter-field>
              <hr>
              <div class="form-group">
                <div class="col-xs-8 col-xs-offset-4">
                  <button type="submit" class="btn btn-primary" ng-disabled="!exp.isValid()">
                    Gerar relatório
                    <i class="fa fa-book"></i>
                  </button>
                  <button type="button" class="btn-link" ng-click="exp.reset()">
                    Alterar tipo
                  </button>
                </div>
              </div>
            </form>
          </div>

          <div uib-accordion-group class="panel-success" is-disabled="exp.step !== 3" is-open="exp.step === 3">
            <uib-accordion-heading>
              <span ng-if="!exp.loadingRelatorio" class="text-white">3. Baixe o relatório</span>
              <span ng-if="exp.loadingRelatorio" class="text-white">3. O seu relatório está sendo gerado, iremos avisar assim que o processo concluir.</span>
            </uib-accordion-heading>

            <div class="text-center">
              <span ng-if="exp.loadingRelatorio">
                <i class="fa fa-spinner fa-spin"></i>
              </span>
              <button ng-if="!exp.loadingRelatorio" type="button" class="btn-link" ng-click="exp.reset()">
                Gerar novo relatório
              </button>
            </div>
          </div>
        </uib-accordion>
      </div>
    </div>
  </div>
</div>
